<template>
  <template-layout :breadCrumbList="breadcrumbComputed">
    <div class="pb-12 px-2 sm:px-4">
      <nav class="flex justify-between items-baseline mb-6">
        <h1 class="text-2xl text-dark">จัดการสิทธิ์</h1>
      </nav>
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 overflow-x-auto">
          <table class="table permission-info border-2 border-primary-1">
              <thead>
                <tr class="bg-primary-1 text-white">
                  <th class="whitespace-nowrap">ระดับ</th>
                  <th class="whitespace-nowrap">สิทธิ์การเข้าถึงเมนู</th>
                  <th class="whitespace-nowrap">สิทธิ์การดำเนินการ</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-b-2 border-primary-1 hover:bg-gray-300" v-for="(data, index) in dataPermission" :key="index">
                  <td>{{ data.level_name }}</td>
                  <td>
                    <div>
                      <div class="form-checkbox-custom pl-6 py-1" v-for="(menu, mIdx) in Object.keys(data.accessible_menus)" :key="mIdx">
                        <label
                          class="form-check-label align-middle"
                          :for="`menu-${menu}${index}`"
                        >
                          <input
                            :id="`menu-${menu}${index}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :true-value="1"
                            :false-value="0"
                            v-model="data.accessible_menus[menu]"
                            :disabled="false"
                          > {{allQuestionnaire[menu]}}
                        </label>
                      </div>
                    </div>
                  </td>
                  <td class="align-baseline">
                    <div >
                      <div class="form-checkbox-custom pl-6 py-1">
                        <label
                          class="form-check-label align-middle"
                          :for="`action1${index}`"
                        >
                          <input
                            :id="`action1${index}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :true-value="1"
                            :false-value="0"
                            v-model="data.permissions.read"
                            :disabled="false"
                          > แสดงผล
                        </label>
                      </div>
                      <div class="form-checkbox-custom pl-6 py-1">
                        <label
                          class="form-check-label align-middle"
                          :for="`action2${index}`"
                          :class="{'text-gray-500' : !data.permissions.read}"
                        >
                          <input
                            :id="`action2${index}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :true-value="1"
                            :false-value="0"
                            v-model="data.permissions.create"
                            :disabled="!data.permissions.read"
                          > เพิ่ม
                        </label>
                      </div>
                      <div class="form-checkbox-custom pl-6 py-1">
                        <label
                          class="form-check-label align-middle"
                          :for="`action3${index}`"
                          :class="{'text-gray-500' : !data.permissions.read}"
                        >
                          <input
                            :id="`action3${index}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :true-value="1"
                            :false-value="0"
                            v-model="data.permissions.update"
                            :disabled="!data.permissions.read"
                          > แก้ไข
                        </label>
                      </div>
                      <div class="form-checkbox-custom pl-6 py-1">
                        <label
                          class="form-check-label align-middle"
                          :for="`action4${index}`"
                          :class="{'text-gray-500' : !data.permissions.read}"
                        >
                          <input
                            :id="`action4${index}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :true-value="1"
                            :false-value="0"
                            v-model="data.permissions.delete"
                            :disabled="!data.permissions.read"
                          > ลบ
                        </label>
                      </div>
                      <div class="form-checkbox-custom pl-6 py-1">
                        <label
                          class="form-check-label align-middle"
                          :for="`action5${index}`"
                          :class="{'text-gray-500' : !data.permissions.read}"
                        >
                          <input
                            :id="`action5${index}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :true-value="1"
                            :false-value="0"
                            v-model="data.permissions.export"
                            :disabled="!data.permissions.read"
                          > นำออก
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
          </table>
          <div class="mt-2 flex justify-end">
            <!-- <button class="btn btn-secondary ml-2">
              ออก
            </button> -->
            <button class="btn btn-primary ml-2" @click="submitData">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </div>
  </template-layout>
</template>
<script setup>
import TemplateLayout from "@/layouts/top-navbar-menu/Main.vue"
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from 'vuex'
import axios from "axios"
import Swal from "sweetalert2";

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});
const store = useStore()
const token = store.getters["userAuth/getToken"];
const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": `application/json; charset=utf-8`,
};

const dataPermission = ref(null)
const allQuestionnaire = ref({dashboard: "Dashboard"})
const getPermission = async () =>{
  const url = `${process.env.VUE_APP_BASE_API}managePermission`;
  const res = await axios.get(url, { headers }).catch(() =>
      Swal.fire({
          icon: "warning",
          text: "ระบบผิดพลาด",
      })
  );
  if (res.status === 200) {
    dataPermission.value = res.data.map(({ _id: id, ...rest}) => ({id, ...rest}))
  }
}
const getAllQuestionnaire = async () => {
  const url = `${process.env.VUE_APP_BASE_API}admin/question_naire`;
  const res = await axios.get(url, { headers, params: {status: "active"}}).catch(() =>
    Swal.fire({
      icon: "warning",
      text: "ระบบผิดพลาด",
    })
  );
  if (res.status === 200) {
    Object.assign(allQuestionnaire.value, res.data.reduce((a,v)=>({...a,[v.name_en]: v.short_name}),{}))
  }
}

const submitData = () =>{
  swalCustom
  .fire({
    text: "ยืนยันบันทึกข้อมูล",
    icon: "info",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ยกเลิก",
  })
  .then(async (result) => {
    if (result.isConfirmed) {
      const res = await axios.put(`${process.env.VUE_APP_BASE_API}managePermission/allLevel`,{...dataPermission.value}, {headers})
      .catch(() => {
        swalCustom.fire({
          text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
          icon: "warning",
          //timer: 3000, //timeOut for auto-close
          confirmButtonText: "ปิด",
        });
      })
      if(res.status == 200){
        swalCustom.fire({
          text: "สำเร็จ",
          icon: "success",
          timer: 3000,
          confirmButtonText: "ปิด",
        })
        .then(()=>getPermission());
      }
    }
  })
}

watch(()=> dataPermission.value, ()=>{
  dataPermission.value.map(item=>{
    if(!item.permissions.read){
      item.permissions.create = 0
      item.permissions.update = 0
      item.permissions.delete = 0
      item.permissions.export = 0
    }
    return item
  })
},
{deep: true})
onMounted(()=>{
  getPermission()
  getAllQuestionnaire()
})
const breadcrumbComputed = computed(()=>{
  return [
    {
      name: "จัดการสิทธิ์",
      active: true,
    }
  ]
})

</script>

<style lang="scss" scoped>
.permission-info{
  tbody{
    tr{
      &:nth-child(even){
        @apply bg-gray-200;
      }
      &:nth-child(odd){
        @apply bg-white;
      }
    }
  }
}
</style>
